if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        /* 2026-09-21: 前後ナビ・枚数・スワイプ・戻るボタン。ModalDialog(media-modal) はマウスの pointerup で
           どこを押しても閉じるので、操作系は pointerup/click の伝播を止める */
        this.items = () => Array.from(this.querySelectorAll('[role="document"] > [data-media-id]'));
        const stop = (e) => e.stopPropagation();
        this.querySelectorAll('[data-modal-nav], [data-modal-back], [data-modal-counter]').forEach((el) => {
          el.addEventListener('pointerup', stop);
          el.addEventListener('pointerdown', stop);
        });
        this.querySelectorAll('[data-modal-nav]').forEach((btn) =>
          btn.addEventListener('click', (e) => { e.stopPropagation(); this.step(Number(btn.dataset.modalNav)); })
        );
        const back = this.querySelector('[data-modal-back]');
        if (back) back.addEventListener('click', (e) => { e.stopPropagation(); this.hide(); });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
        });
        let sx = null, sy = null;
        this.addEventListener('touchstart', (e) => { const t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (sx === null) return;
          const t = e.changedTouches[0]; const dx = t.clientX - sx; const dy = t.clientY - sy; sx = sy = null;
          if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) this.step(dx < 0 ? 1 : -1);
        }, { passive: true });
        // SP: 画像の外(余白)をタップしたら閉じる (マウスは ModalDialog が処理)
        this.addEventListener('click', (e) => {
          if (window.matchMedia('(max-width: 749px)').matches && e.target.matches('[role="document"], .product-media-modal__dialog')) this.hide();
        });
      }

      currentIndex() {
        const items = this.items();
        return Math.max(0, items.findIndex((el) => el.classList.contains('active')));
      }

      step(delta) {
        const items = this.items();
        if (!items.length) return;
        const next = (this.currentIndex() + delta + items.length) % items.length;
        this.activate(items[next]);
      }

      activate(el) {
        this.items().forEach((x) => x.classList.toggle('active', x === el));
        // PC も 1 枚表示 (pdp-fv.css) なので scrollIntoView は不要。切替時は先頭に戻すだけ
        const container = this.querySelector('[role="document"]');
        if (container) container.scrollTop = 0;
        this.updateCounter();
      }

      updateCounter() {
        const c = this.querySelector('[data-modal-counter]');
        if (c) c.textContent = `${this.currentIndex() + 1} / ${this.items().length}`;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        // 2026-09-24: 1 枚表示にしたため、lazy の画像は切り替えた瞬間に読み込みが始まり数秒真っ白になっていた
        // (実測: 4〜11 枚目が切替直後 2x2px・7 枚目は 2.5 秒後も未読込)。開いた時点で全枚を先読みする
        this.querySelectorAll('[role="document"] img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        this.updateCounter();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
